import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VRow,_vm._l((_vm.submissionStats.LabelStatistics),function(item){return _c(VCol,{key:item.Id,staticClass:"text-md-center"},[_c('h2',[_vm._v(_vm._s(item.SeedLabel.SeedPackLabel))]),_c('Doughnut',{attrs:{"data":[item.Planted, item.Germinated]}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }